define((require) => {
    "use strict";

    var EditorEvents    = require("shared/services/EditorEvents"),
        ErrorHandler    = require("shared/services/error/ErrorHandler"),
        NotificationBar = require("editor/ui/notificationbar/NotificationBar"),
        Permissions     = require("shared/security/Permissions"),
        RestApi         = require("shared/services/RestApi"),
        SyncManager     = require("shared/services/sync/SyncManager"),
        ViewController  = require("editor/util/ViewController");

    /**
     * <tt>ViewController</tt> for the <tt>ManageUsersItemView</tt>.
     *
     * Responsible for handling role/privilege changes.
     *
     * @see  ManageUsersView
     * @author Kim
     */
    return ViewController.extend({

        /**
         * Invoked when the view (<tt>ManageUsersItemView</tt>) triggers a <tt>roleChanged</tt> event.
         */
        onViewRoleChanged: function() {
            var self = this,
                scope = this.view,
                role = scope.model.get("role"),
                old = scope._role;

            if (old === role) {
                return;
            }

            var displayName = scope.model.get("displayName");

            scope._role = role;

            // Privilege changes need to be saved through a separate endpoint. Note that the model id of that
            // of the specific user, not of the currently logged in principal...
            SyncManager.sync({
                method: "update-permissions",
                role:   Permissions.Roles.CREATOR, // must be at least a creator to update other users
                fn: {
                    url:          RestApi.pathToCollectionOnResource(RestApi.Collections.USERS, scope.model.get("id"), "permissions"),
                    type:        "PUT",
                    contentType: "text/plain",
                    data:        role.name
                },
                errorHandler: function(error) {
                    return this._handleError(displayName, error);
                }.bind(this)

            }, scope.model).promise().done(() => {
                var msg = ".";
                if (!scope.model.isConfirmed() && Permissions.Roles.SPECTATOR.not(role)) { // Spectator is the default when unconfirmed
                    msg += " The role will not take affect until the user is confirmed.";
                }
                NotificationBar.open("The role for " + displayName + " has been updated from " + old.name + " to " + role.name + msg, {queue: false, closeDelay: 10000});

                // To ensure we update the display name for any user now confirmed, or any user not confirmed
                // being downgraded to Spectator...
                scope.render();

                var eventProperties = {
                    userId: self.model.get("id"),
                    username: self.model.get("username"),
                    oldRole: old.name,
                    newRole: role.name,
                    updatedProperty: "role",
                    updatedValue: role.name,
                    triggerOrigin: "UserPermissionsSelect"
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_USER, eventProperties);
            }).fail(() => {
                // Make sure we set the old role on this view before we update the model, or we would try and
                // update with the old role...
                scope._role = old;
                scope.model.set("role", old); // Ensure we display the old role on failure...
            });
        },

        _handleError: function(displayName, error) {
            // Resolve error message placeholders...
            ErrorHandler.inject(error, {
                method:   "update",
                name:     "the role for " + displayName,
                typeName: "User"
            });
            return "alert";
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/ManageUsersItemViewController.js